import { qsOptional, safeDefineElement } from '@/scripts/core/global'
import { DeferredMedia } from '@/scripts/interactive-defer/deferred-media'
import { DetailsDisclosure } from '@/scripts/interactive-defer/details-disclosure'
import { CartDrawer } from '@/scripts/interactive-defer/cart-drawer'
import { CartNote } from '@/scripts/interactive-defer/cart-note'
import { CartDrawerItems } from '@/scripts/interactive-defer/cart-drawer-items'
import { CartRemoveButton } from '@/scripts/interactive-defer/cart-remove-button'
import { CartItems } from '@/scripts/interactive-defer/cart-items';
import { PredictiveSearch } from '@/scripts/interactive-defer/predictive-search';
import { QuantityInput } from '@/scripts/theme/quantity-input';
import { SearchForm } from '@/scripts/interactive-defer/search-form';
import { HeaderMenu } from '@/scripts/interactive-defer/header-menu';
import { DetailsModal } from '@/scripts/interactive-defer/details-modal';
import { MenuDrawer } from '@/scripts/interactive-defer/menu-drawer';
import { HeaderDrawer } from '@/scripts/interactive-defer/header-drawer';
import { ModalDialog } from '@/scripts/interactive-defer/modal-dialog';
import { ModalOpener } from '@/scripts/interactive-defer/modal-opener';
import { DynamicShippingBar } from '@/scripts/interactive-defer/dynamic-shipping-bar'
import { WaitlistForm } from '@/scripts/interactive-defer/waitlist-form'
import { KlaviyoForm } from '@/scripts/interactive-defer/klaviyo-form'
import { WaitlistPopup, WelcomePopup } from '@/scripts/interactive-defer/welcome-popup'
import { DynamicQuizStub } from '@/scripts/interactive-defer/dynamic-quiz-stub'
import { DynamicQuiz } from '@/scripts/interactive-defer/dynamic-quiz'
import { DynamicQuizResult } from '@/scripts/interactive-defer/dynamic-quiz-result'
import { SelectShadeTooltip } from '@/scripts/interactive-defer/select-shade-tooltip'
import { ProductRecommendations } from '@/scripts/interactive-defer/product-recommendations';
import { BaSwiper } from '@/scripts/interactive-defer/ba-swiper'
import { ExpandableContent } from '@/scripts/interactive-defer/expandable-content'
import { LocalizationForm } from '@/scripts/interactive-defer/localization-form'
import { TutorialVideos } from '@/scripts/interactive-defer/tutorial-videos'


safeDefineElement(BaSwiper)
safeDefineElement(DeferredMedia)
safeDefineElement(DetailsDisclosure)
safeDefineElement(ExpandableContent)
safeDefineElement(SelectShadeTooltip)
safeDefineElement(ProductRecommendations)
safeDefineElement(QuantityInput)
safeDefineElement(CartDrawer)
safeDefineElement(CartNote)
safeDefineElement(CartItems)
safeDefineElement(CartDrawerItems)
safeDefineElement(CartRemoveButton)
safeDefineElement(SearchForm)
safeDefineElement(PredictiveSearch)
safeDefineElement(HeaderMenu)
safeDefineElement(DetailsModal)
safeDefineElement(MenuDrawer)
safeDefineElement(HeaderDrawer)
safeDefineElement(ModalDialog)
safeDefineElement(ModalOpener)
safeDefineElement(DynamicShippingBar)
safeDefineElement(KlaviyoForm)
safeDefineElement(WelcomePopup)
safeDefineElement(WaitlistPopup)
safeDefineElement(WaitlistForm)
safeDefineElement(DynamicQuizStub)
safeDefineElement(DynamicQuiz)
safeDefineElement(DynamicQuizResult)
safeDefineElement(LocalizationForm)
safeDefineElement(TutorialVideos)

function openFromUrlParam() {
	const url = new URL(window.location.href);
	const urlParams = url.searchParams;
	const openParam = urlParams.get('open');

	switch (openParam) {
		case 'cart':
			const cartDrawer = qsOptional<CartDrawer>('cart-drawer');
			if (cartDrawer) {
				cartDrawer.open();
			}
			break;
		case 'quiz':
			const quizStub = qsOptional<DynamicQuizStub>('dynamic-quiz-stub');
			if (quizStub) {
				void quizStub.initializePopup();
			}
			break;
		default:

			break;
	}
/*	if (openParam !== null) {
		urlParams.delete('open');

		// Construct the new URL without the 'open' parameter
		const newUrl = url.origin + url.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '') + url.hash;

		// Update the URL without reloading the page
		window.history.replaceState({}, '', newUrl);
	}*/
}

function assignBlankTargetToExternalLinks(): void {
	const links = document.getElementsByTagName('a')


	for (let i = 0; i < links.length; i++) {
		const link = links[i]
		const href = link.getAttribute('href')
		if (!href) continue
		if (!href.startsWith('http')) continue
		if (href.startsWith('#')) continue
		if (href.startsWith('/')) continue
		if (href.startsWith('mailto:')) continue
		if (href.startsWith('?')) continue
		link.setAttribute('target', '_blank')
		link.setAttribute('rel', 'noopener noreferrer')
	}
}

openFromUrlParam()
assignBlankTargetToExternalLinks()

